var render = function render(){var _vm=this,_c=_vm._self._c;return _c('spinner',{attrs:{"size":_vm.size,"line-fg-color":"#025542"}})
}
var staticRenderFns = []

export { render, staticRenderFns }